module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"status":"@:labels.status"},"fr":{"status":"@:labels.status"}}')
  delete Component.options._Ctor
}
